module.exports = __webpack_public_path__ + "images/emoji/mouse.617fdf7587fbcf4ee204.png";